//https://github.com/angular/angular.js/pull/10732

var angular = require('angular');
var mask = require('./dist/mask');

module.exports = 'ui.mask';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-ui-mask/index.js
 ** module id = 347
 ** module chunks = 0
 **/